import ArrowHead from 'components/Common/SvgIcons/ArrowHead'
import { DateRanges } from '../../../__generated__/api-types-and-hooks'
import { DateRangesGrowthLabellings } from 'config'
import { AppStatValue } from 'components/AppDataReport/AppData/AppData.style'
import Loader from 'components/Loaders'
import React from 'react'
import colors from 'colors'
import { formatNumber } from 'utils/helper'

interface IAppAccountingStatCardProps {
  chartValue: number
  chartGrowthValue: number
  isLoading: boolean
  dateRange: DateRanges
}

export const AppAccountingStatValue = ({
  isLoading,
  chartValue,
  chartGrowthValue,
  dateRange,
}: IAppAccountingStatCardProps) => {
  return (
    <>
      {isLoading && <Loader loader="TableLoader" />}
      {chartValue !== null && chartValue !== undefined && (
        <div className={`flex gap-2 flex-col ${isLoading && 'hidden'} `}>
          <AppStatValue>${formatNumber(Number(chartValue || 0))}</AppStatValue>
          <div className="flex gap-3 text-2xl font-primary leading-7">
            {chartGrowthValue !== 0 && (
              <ArrowHead
                color={chartGrowthValue > 0 ? colors.green.DEFAULT : colors.primary.error}
                down={chartGrowthValue < 0}
              />
            )}
            {chartGrowthValue !== 0 && (
              <span className={chartGrowthValue > 0 ? 'text-green' : 'text-primary-error'}>
                {chartGrowthValue || 0}%
              </span>
            )}
            {chartGrowthValue === 0 && <span>{0}%</span>}
            {DateRangesGrowthLabellings[dateRange ?? DateRanges.ThisYearToDate]}
          </div>
        </div>
      )}
    </>
  )
}
